


















































import { Component, Vue } from 'vue-property-decorator';
import CircleLoader from '@/components/CircleLoader.vue';
import Card from '@/components/courses/Card.vue';
import TabMenu from '@/components/courses/TabMenu.vue';
import ToggleView from '@/components/courses/ToggleView.vue';
import UserMenu from '@/components/courses/UserMenu.vue';
import SearchInput from '@/components/SearchInput.vue';
import { getSortOptions, UPDATED_DESC } from '../../types/constants';
import { CourseParam, ICourse, ICoursesCounters, ICourseTabMenu } from '../../types/types';

@Component({ components: { Card, SearchInput, ToggleView, UserMenu, TabMenu, CircleLoader } })
export default class Courses extends Vue {
  cardView = 'tile';

  currentTabIndex = 0;

  isAnimate = false;

  handleScroll = this.loadMoreCourses;

  search = '';

  activeSort = UPDATED_DESC;

  sortOptions = getSortOptions(this.$t);

  get isLoading(): boolean {
    return this.$store.getters['courses/isLoading'];
  }

  get isCanLoadMoreCourses(): boolean {
    return this.$store.getters['courses/isCanLoadMoreCourses'];
  }

  get courses(): ICourse[] {
    return this.$store.getters['courses/courses'];
  }

  get counters(): ICoursesCounters {
    return this.$store.getters['courses/counters'];
  }

  get listCounters(): ICoursesCounters {
    return this.$store.getters['courses/listCounters'];
  }

  get currentFilter(): string {
    return this.$store.getters['courses/options'].filter;
  }

  get tabs(): ICourseTabMenu[] {
    return [
      { key: CourseParam.Active, counter: this.listCounters.active, text: 'activeCourses' },
      { key: CourseParam.Completed, counter: this.listCounters.completed, text: 'completedCourses' }
    ];
  }

  get currentTab() {
    return this.tabs[this.currentTabIndex];
  }

  get emptyTabText() {
    if (this.search) {
      return this.$t('noResultsFound');
    }

    return this.currentFilter === CourseParam.Active ? this.$t('emptyActiveCourses') : this.$t('emptyCompletedCourses');
  }

  get titleLength() {
    return this.cardView === 'list' ? 255 : 74;
  }

  mounted() {
    document.addEventListener('scroll', this.handleScroll);

    this.isAnimate = true;
  }

  destroyed() {
    this.$store.dispatch('courses/resetState');
    document.removeEventListener('scroll', this.handleScroll);
  }

  toggleView(viewName: string) {
    this.cardView = viewName;
  }

  async getCourses(param: CourseParam, i: number, isNewSet = false) {
    this.currentTabIndex = i;
    this.isAnimate = false;

    this.$store.commit('courses/ACTIVE_COURSE_LOADER');
    const promises = [
      this.$store.dispatch('courses/getCourses', {
        filter: param,
        search: this.search,
        isNewSet,
        sort: this.activeSort
      })
    ];

    if (isNewSet) {
      promises.push(this.$store.dispatch('courses/getAllCoursesCounter', { search: this.search }));
    } else {
      promises.push(this.$store.dispatch('courses/getCourseCounter', { param, search: this.search }));
    }

    await Promise.all(promises);
    this.$store.commit('courses/DISABLE_COURSE_LOADER');
    this.isAnimate = true;
  }

  async loadMoreCourses() {
    const scrollTop = window.scrollY;
    const scrollHeight = window.innerHeight;
    const contentHeight = document.body.scrollHeight;

    if (
      contentHeight - scrollTop - scrollHeight < 400 &&
      this.courses.length < this.currentTab.counter &&
      !this.isCanLoadMoreCourses
    ) {
      this.$store.commit('courses/ACTIVE_LOAD_MORE_COURSES');
      await this.$store.dispatch('courses/getCourses', {
        skip: this.courses.length,
        search: this.search,
        sort: this.activeSort
      });
      this.$store.commit('courses/DISABLE_LOAD_MORE_COURSES');
    }
  }

  async onSearchInputChanged(value: string) {
    this.search = value;
    this.getCourses(this.currentFilter as CourseParam, this.currentTabIndex, true);
  }

  async onSortInputChanged(value: string) {
    this.activeSort = value;
    this.getCourses(this.currentFilter as CourseParam, this.currentTabIndex, true);
  }
}
